/**
 * Lightweight event helper for signalling backend unavailability.
 * Lives in its own module so api.ts can import it without pulling
 * in the React context (which itself imports API_BASE_URL from api.ts).
 */
const MAINTENANCE_EVENT = 'cloudincidents:backend-unavailable';

export function emitBackendUnavailable(): void {
  window.dispatchEvent(new CustomEvent(MAINTENANCE_EVENT));
}

export { MAINTENANCE_EVENT };
